import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { ellipsify } from '../../typography/ellipsify';
import { useTheme } from '../../theming/useTheme';
import { VrLineHeight } from '../../theming/verticalRhythm/verticalRhythm';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';

export const CARD_CAPTION_CONTAINER_TYPES = {
  HORIZONTAL: 'horizontal',
  ON_TOP: 'onTop',
  VERTICAL: 'vertical',
  DEFAULT: 'default',
};
const componentConfigThemeKey = 'cardCaptionContainer';

interface CardCaptionContainerComponentDataProps {
  numberOfLines: number
  type: string
  children: any
}

interface CardCaptionContainerComponentThemeProps {
  vrLineHeight: VrLineHeight
}

type CardCaptionContainerComponentProps = CardCaptionContainerComponentDataProps & CardCaptionContainerComponentThemeProps;

class CardCaptionContainerComponent extends React.Component<CardCaptionContainerComponentProps> {
  createStyles = (vrLineHeight: VrLineHeight) => StyleSheet.create({
    [CARD_CAPTION_CONTAINER_TYPES.DEFAULT]: {
      overflow: 'hidden',
    },
    [CARD_CAPTION_CONTAINER_TYPES.ON_TOP]: {
      background: 'transparent',
      position: 'absolute',
      bottom: 0,
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5}px`,
      },
    },
    [CARD_CAPTION_CONTAINER_TYPES.HORIZONTAL]: {
      flex: '1 1 66%',
      position: 'relative',
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5}px`,
        '-webkitLineClamp': '2',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5}px`,
        '-webkitLineClamp': '3',
        flex: '0 0 66.66%',
      },
    },
    [CARD_CAPTION_CONTAINER_TYPES.VERTICAL]: {
      [MEDIA_BREAKPOINTS.X_LARGE]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.LARGE]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        margin: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5}px`,
      },
    },
  });

  render() {
    const { numberOfLines, children, type, vrLineHeight } = this.props;
    const cardStyles = this.createStyles(vrLineHeight);
    // @ts-ignore TS2345
    const { style } = StyleSheet.create(ellipsify(numberOfLines));

    return (
      <div className={css(
        style,
        cardStyles[CARD_CAPTION_CONTAINER_TYPES.DEFAULT],
        cardStyles[type],
      )}
      >
        {children}
      </div>
    );
  }
}

const mapThemeProps = (theme: CardCaptionContainerComponentThemeProps) => ({
  vrLineHeight: theme.vrLineHeight,
});

export const CardCaptionContainer = (props: CardCaptionContainerComponentDataProps) => {
  const themeContext = useTheme(componentConfigThemeKey, mapThemeProps);
  return <CardCaptionContainerComponent {...themeContext} {...props} />;
};
